import { useQuery } from "react-query";
import axiosInstance from "../axios/axiosInstance";

// common function to fetch games
// applies filters for visible games and any additional params passed in
const fetchGames = async (params = "") => {
  const separator = params ? "&" : "";
  const { data } = await axiosInstance.get(
    `games?filters[visible][$eq]=true${separator}${params}`
  );
  return data;
};

const getGamesFn = () => fetchGames("featuredGame=true&editorsPick=true");

export function useGames() {
  return useQuery(["games", 1], getGamesFn);
}

const getFilteredGamesFn = (filter) => {
  return fetchGames(`filters[categories][name][$eq]=${filter}`);
}

// shall we move the burden of filtering to the backend?
export function useFilteredGames(filter) {
  const queryKey = ["filteredGames", { category: filter }];
  return useQuery(queryKey, () => getFilteredGamesFn(filter));
}

const getSingleGameFn = async (gameId) => {
  const { data } = await axiosInstance.get(`games/${gameId}`);
  return data;
};

export function useSingleGame(gameId) {
  return useQuery("game", () => getSingleGameFn(gameId));
}
